import React, { useEffect, useState } from 'react';
import {
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { Col, Row } from 'antd';
import { toCurrency, toEuroSimpleDisplayK } from 'utils/utils';
import ProgressBarChart from 'components/theme_components/ProgressBarChart';
import Title from 'antd/lib/typography/Title';
import { BonificationResponse, getLatestBonification } from 'services/parametersService';
import { TpAuthorizationResponse } from 'services/thirdParty';

export type ReadOnlyActivityCardProps = {
  data: TpAuthorizationResponse;
  refetch?: any;
  tptype?: string;
  showBonification?: boolean;
};

const isDateExpired = (endDate: any) => {
  const today = new Date();
  const end = new Date(endDate);
  return end <= today;
};

const ReadOnlyActivityCard = ({ data, refetch, tptype = "CONC", showBonification = true }: ReadOnlyActivityCardProps) => {
  const isExpired = isDateExpired(data.enddate) ?? true;

  return (
    <div style={{ 
      border: '1px solid #d9d9d9',
      borderRadius: '4px',
      backgroundColor: '#fff',
      marginBottom: 12,
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#3B55B9',
        color: 'white',
        padding: '8px 16px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 500
      }}>
        Affichage de l'état de la ligne
      </div>

      <div style={{ padding: '16px' }}>
        {/* Occasion Section */}
        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontSize: '14px', fontWeight: 500, color: '#666', marginBottom: '4px' }}>
             <div style={{ fontSize: '14px', fontWeight: 500, color: '#666', marginBottom: '4px' }}>
            {data?.prcodelabel}
          </div>
          </div>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            fontSize: '13px',
            gap: '8px'
          }}>
            {data?.authstatus === 'ACTIVE' && !isExpired ? (
              <>
                <CheckOutlined style={{ color: '#52c41a', fontSize: '12px' }} />
                <span>Activité autorisée</span>
              </>
            ) : (
              <>
                <CloseOutlined style={{ color: '#ff4d4f', fontSize: '12px' }} />
                <span>Activité non autorisée</span>
              </>
            )}
            <span>• {data.enddate}</span>
          </div>
        </div>

        <Row gutter={24}>
          {/* Financial Data */}
          <Col xs={24} sm={24} md={16} lg={16}>
            <Row gutter={[16, 12]}>
              <Col xs={12} sm={12}>
                <div>
                  <div style={{ 
                    fontSize: '11px', 
                    color: '#666', 
                    marginBottom: '2px',
                    fontWeight: 500
                  }}>
                    Reste dispo sur N.L
                  </div>
                  <div style={{ 
                    fontSize: '16px', 
                    fontWeight: 600,
                    color: '#000'
                  }}>
                    {toCurrency(data?.authavailableamount)}
                  </div>
                </div>
              </Col>
              
              <Col xs={12} sm={12}>
                <div>
                  <div style={{ 
                    fontSize: '11px', 
                    color: '#666', 
                    marginBottom: '2px',
                    fontWeight: 500
                  }}>
                    Reste dispo MPEA
                  </div>
                  <div style={{ 
                    fontSize: '16px', 
                    fontWeight: 600,
                    color: '#000'
                  }}>
                    {toCurrency(data?.authavailableamountmpea)}
                  </div>
                </div>
              </Col>

              {tptype === 'CONC' && (
                <>
                  <Col xs={12} sm={12}>
                    <div>
                      <div style={{ 
                        fontSize: '11px', 
                        color: '#666', 
                        marginBottom: '2px',
                        fontWeight: 500
                      }}>
                        Reste dispo avec perméab sur N.L
                      </div>
                      <div style={{ 
                        fontSize: '16px', 
                        fontWeight: 600,
                        color: '#000'
                      }}>
                        {toCurrency(data?.authavailableamountwithpermeability)}
                      </div>
                    </div>
                  </Col>
                  
                  <Col xs={12} sm={12}>
                    <div>
                      <div style={{ 
                        fontSize: '11px', 
                        color: '#666', 
                        marginBottom: '2px',
                        fontWeight: 500
                      }}>
                        Reste dispo avec perméab MPEA
                      </div>
                      <div style={{ 
                        fontSize: '16px', 
                        fontWeight: 600,
                        color: '#000'
                      }}>
                        {toCurrency(data?.authavailableamountmpeawithpermeability)}
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </Col>

          {/* Progress Charts */}
          <Col xs={24} sm={24} md={8} lg={8}>
            <Row gutter={[12, 12]} justify="center">
              <Col xs={12} sm={12} md={24} lg={12}>
                <div style={{ textAlign: 'center' }}>
                  <ProgressBarChart
                    percentageValue={Number(
                      data?.pourcentageConsumedNLimit?.toFixed(0) || 0
                    )}
                    size={90}
                    label={toEuroSimpleDisplayK(data?.authamount)}
                    labelAbove="Normal limit"
                    multicolor
                    color="#ff4d4f"
                  />
                </div>
              </Col>
              <Col xs={12} sm={12} md={24} lg={12}>
                <div style={{ textAlign: 'center' }}>
                  <ProgressBarChart
                    percentageValue={Number(
                      typeof data?.pourcentageConsumedMPEA === "number"
                        ? data.pourcentageConsumedMPEA.toFixed(0)
                        : 0
                    )}
                    size={90}
                    label={toEuroSimpleDisplayK(data?.authcalculatedamount)}
                    labelAbove="MPEA"
                    multicolor
                    color="#faad14"
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ReadOnlyActivityCard;